'use strict';

module.exports = [function () {
    return {
        replace: true,
        scope: true, 
        template: require('./formButtonNoPerms.html')
    };
}];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/formButtonNoPerms.js
// module id = 382
// module chunks = 0